'use strict';

/**
 * Base class for a router
 *
 * @category   Router
 * @module     base
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Backbone = require('backbone');
var Marionette = require('backbone-marionette');

var Router = Marionette.AppRouter.extend({
    navigationCounter: 0,

    before: function(params, next){
        next();
    },

    after: function(){},

    initialize: function (options) {
        this.history = [];
        Marionette.AppRouter.prototype.initialize.apply(this, arguments);
    },

    /**
     * Overwrites backbone function to support before/after callbacks
     */
    route: function(route, name, callback) {
        if (!_.isRegExp(route)) {
            route = this._routeToRegExp(route)
        };
        if (_.isFunction(name)) {
            callback = name;
            name = '';
        }
        if (!callback) {
            callback = this[name]
        };

        var router = this;

        Backbone.history.route(route, function(fragment) {
            var args = router._extractParameters(route, fragment);

            var next = function(){
                router.history.push(fragment);
                router.execute(callback, args);
                router.trigger.apply(router, ['route:' + name].concat(args));
                router.trigger('route', name, args);
                Backbone.history.trigger('route', router, name, args);
                router.after.apply(router, args);
            }
            router.before.apply(router, [args, next]);
        });

        return this;
    },

    //backbone original
    // route: function(route, name, callback) {
    //     if (!_.isRegExp(route)) route = this._routeToRegExp(route);
    //     if (_.isFunction(name)) {
    //         callback = name;
    //         name = '';
    //     }
    //     if (!callback) callback = this[name];
    //
    //     var router = this;
    //
    //     Backbone.history.route(route, function(fragment) {
    //         var args = router._extractParameters(route, fragment);
    //             router.execute(callback, args);
    //             router.trigger.apply(router, ['route:' + name].concat(args));
    //             router.trigger('route', name, args);
    //             Backbone.history.trigger('route', router, name, args);
    //     });
    //
    //     return this;
    // },

    navigate: function(fragment, options) {
        var currentFragment = Backbone.history.getFragment();
        var requestedFragment = Backbone.history.getFragment(fragment);

        if (requestedFragment !== currentFragment) {
            //Only update the counter if route changes. We should probably also move the actual navigating here, but I can't forsee regressions and sideeffects, so I don't right now
            this.navigationCounter++;
        }

        Marionette.AppRouter.prototype.navigate.apply(this, arguments);
    },

    getNavigationCounter: function() {
        return this.navigationCounter;
    },
});

module.exports = Router;